<div class="table">
  <form #formMeasurementTable="ngForm" novalidate>
    <nz-table
      nzTableHeaderStyle
      #editRowTable
      [nzData]="[1]"
      [nzFrontPagination]="false"
      [nzShowPagination]="false"
      [nzScroll]="{ x: '720px', y: 'auto' }"
      nzSize="small"
      [tableIndex]="tableIndex"
      nzTableLayout="fixed">
      <thead>
        <tr class="header">
          <th [nzWidth]="showLastValue ? '40%' : forTemplates ? '50%' : '45%'">MEDIDA</th>
          <th nzWidth="20%" *ngIf="!forTemplates && showLastValue">ÚLTIMO VALOR</th>
          <th [nzWidth]="showLastValue ? '20%' : '25%'" *ngIf="!forTemplates">VALOR</th>
          <th [nzWidth]="showLastValue ? '15%' : forTemplates ? '50%' : '25%'">UNIDAD DE MEDIDA</th>
          <th [nzWidth]="'50px'" [nzRight]="measurementsRow.length> 0 ? true : false"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of measurementsRow; index as i">
          <!--NOMBRE DE LA MEDIDA-->
          <td>
            <!-- <p class="cursor-pointer option-selected" (click)="data.showEdit = true;" *ngIf="data.measurementSelected">{{ data.name }}</p> -->
            <i *ngIf="showIsTemplate && data.fromTemplate" nz-popover="" nzPopoverTitle="" [nzPopoverContent]="'Medida de la plantilla'"
              class="icon-information" nz-icon nzType="info-circle" nzTheme="outline"></i>
            <nz-select
              nzShowSearch
              nzPlaceHolder="Busca la medida que quieras registrar"
              name="measurement{{i}}"
              #ngMeasurement="ngModel"
              [required]="required && data.status !== measurementRowEnum.NEW"
              [(ngModel)]="data._id"
              [nzOptionHeightPx]="!isLoadingFirstMenus ? 70 : 80"
              [nzServerSearch]="true"
              [nzShowSearch]="true"
              [nzOptionOverflowSize]="5"
              [nzDropdownRender]="renderTemplate"
              (ngModelChange)="onSelectMeasurement($event, i); onChangeRow(i)"
              (nzOnSearch)="onSearchMeasurement($event)"
              (nzOpenChange)="onCloseSelect($event, data)"
              (nzScrollToBottom)="loadMoreMeasurements()">
              <ng-container *ngIf="!isLoadingFirstMenus; else loadingFirstMenus">
                <ng-container *ngIf="data.showEdit">
                  <nz-option nzCustomContent [nzValue]="data.measurementSelected?._id" [nzLabel]="data.measurementSelected?.name_es">
                    <div class="custom-option-row-menu">
                      <p class="text-info text-upper-case truncate">{{ data.measurementSelected?.name_es }}</p>
                      <p class="text-info-sm text-lower-case first-letter-upper mt-xxs">{{ data.measurementSelected?.category |
                        getTranslateEnum:'measurementsCategory' }}</p>
                      <nz-divider style="margin: 10px 0 0 0;"></nz-divider>
                    </div>
                  </nz-option>
                </ng-container>
                <ng-container *ngIf="!data.showEdit">
                  <nz-option nzCustomContent *ngFor="let measurement of (measurementsType$ | async)" [nzValue]="measurement?._id"
                    [nzLabel]="measurement?.name_es">
                    <div class="custom-option-row-menu">
                      <p class="text-info text-upper-case truncate">{{ measurement?.name_es }}</p>
                      <p class="text-info-sm text-lower-case first-letter-upper mt-xxs">{{ measurement.category |
                        getTranslateEnum:'measurementsCategory' }}</p>
                      <nz-divider style="margin: 10px 0 0 0;"></nz-divider>
                    </div>
                  </nz-option>
                </ng-container>
              </ng-container>
              <ng-template #loadingFirstMenus>
                <nz-option nzCustomContent [nzDisabled]="true">
                  <div class="tw-h-4">
                    <nz-spin class="mt-xlg mb-xlg"></nz-spin>
                  </div>
                </nz-option>
              </ng-template>
            </nz-select>
            <ng-template #renderTemplate>
              <nz-spin class="tw-h-0.5 mt-sm mb-sm" *ngIf="isLoadingMenus"></nz-spin>
            </ng-template>
            <app-message-field *ngIf="data.status !== measurementRowEnum.NEW" [field]="ngMeasurement"></app-message-field>
          </td>

          <td *ngIf="!forTemplates && showLastValue">
            <nz-input-number
              #ngLastValue="ngModel"
              nzPlaceHolder="No hay valor previo"
              name="lastValue{{i}}"
              [(ngModel)]="data.lastValue"
              [nzMin]="0.1"
              [nzStep]="1"
              [nzFormatter]="formatterDecimals"
              [nzDisabled]="true"
              (nzBlur)="onChangeRow(i)">
            </nz-input-number>
          </td>

          <!--VALOR DE LA MEDIDA-->
          <td *ngIf="!forTemplates">
            <nz-input-number
              #ngValue="ngModel"
              nzPlaceHolder="Ingresa el valor"
              name="value{{i}}"
              [(ngModel)]="data.value"
              [nzMin]="0.1"
              [nzStep]="1"
              [nzDisabled]="!data._id"
              [required]="required && data.status !== measurementRowEnum.NEW"
              (nzBlur)="onEmitVerifyValidRow(i); onChangeRow(i)">
             <!--  (ngModelChange)="onEmitVerifyValidRow(i)"> Se quito porque los valores no se estaban mandando correctamente -->
            </nz-input-number>
            <app-message-field *ngIf="data.status !== measurementRowEnum.NEW" [field]="ngValue"></app-message-field>
          </td>

          <!--UNIDAD DE MEDIDA-->
          <td>
            <nz-select
              #ngUnit="ngModel"
              name="unit{{i}}"
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Selecciona la unidad"
              [(ngModel)]="data.unit"
              [nzDisabled]="!data._id || data.unitMeasurementDefault?._id"
              [required]="required && data.status !== measurementRowEnum.NEW"
              (ngModelChange)="onEmitVerifyValidRow(i); onChangeRow(i)">
              <nz-option *ngFor="let measurementUnit of data.unitMeasurement" [nzLabel]="data.value> 1 ? measurementUnit.namePlural_es :
                measurementUnit.name_es" [nzValue]="measurementUnit._id"></nz-option>
            </nz-select>
            <app-message-field *ngIf="data.status !== measurementRowEnum.NEW" [field]="ngUnit"></app-message-field>
          </td>

          <!--ACCIONES-->
          <td nzRight style="min-height: 50px;">
            <div class="action-column">
              <!-- <button
                nz-button
                nzType="primary"
                nzDanger
                (click)="onRemoveMeasurementTable(i, data._id)"
                *ngIf="data.status !== measurementRowEnum.NEW">
                <i nz-icon nzType="delete" nzTheme="outline"></i>
              </button> -->
              <div
                nz-popover=""
                nzPopoverTitle=""
                nzPopoverContent="Eliminar"
                nzPopoverPlacement="left"
                class="tw-h-7.5 icon-action danger"
                (click)="onRemoveMeasurementTable(i, data._id)" *ngIf="data.status !== measurementRowEnum.NEW">
                <i nz-icon nzType="delete" nzTheme="outline"></i>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </form>
</div>
<div class="d-flex justify-content-end mt-xlg" *ngIf="showBtnAction">
  <button nz-button nzType="primary" [disabled]="measurementsRow?.length === 1" (click)="onEmitSaveMeasurementsTable()">
    <i nz-icon nzType="save" nzTheme="outline"></i>
    GUARDAR MEDIDAS
  </button>
</div>
